import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OTabContainer as OTabContainerComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OTabContainerConfig = {
  emptyLabel: 'OTabContainer',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-tab-container`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OTabContainer = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-tab-container-comp"
      data-component-name="o-tab-container"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OTabContainerConfig} {...props}>
        <OTabContainerComp {...props} />
      </EditableComponent>
    </div>
  );
};
